export default "__VITE_ASSET__C$$sMhus__"